import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useState } from "react";
import "../../css/residency/ManageResidency.css";
import "../../css/Manage.css";
import moment from "moment";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import ResidencyApi from "../../api/residencyApi";

const ManageResidency = () => {
  const navigate = useNavigate();
  const { page } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const downloadExcel = async () => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "주문자명", key: "ordererName", width: 40 },
      { header: "휴대전화", key: "ordererTel", width: 40 },
      { header: "원가", key: "originPrice", width: 40 },
      { header: "쿠폰 할인", key: "couponDiscountPrice", width: 40 },
      { header: "마일리지 사용", key: "useMileage", width: 40 },
      { header: "결제", key: "paymentPrice", width: 40 },
      { header: "생성일", key: "createdAt", width: 40 },
      { header: "상태", key: "state", width: 40 },
      { header: "이용기간", key: "period", width: 40 },
    ];

    excel.forEach((item) => {
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "거주권 관리.xlsx");
  };

  const [arr, setArr] = useState([]);
  const [excel, setExcel] = useState([]);

  const [residencyData, setResidencyData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [pageIndex, setPageIndex] = useState([]);
  const [postsPerPage, setPostsPerPage] = useState(null);
  const [tel, setTel] = useState([]);

  useEffect(() => {
    setSearchKeyword(
      searchParams.get("keyword") ? searchParams.get("keyword") : ""
    );
    setCurrentPage(Number(page));
    GetResidencyList();
  }, [currentPage, location]);

  const GetResidencyList = async () => {
    try {
      const list = (
        await ResidencyApi.List({
          page: currentPage,
          size: 10,
          keyword: searchParams.get("keyword"),
        })
      ).data.data;

      setResidencyData(list.content);
      setTotalCount(list.totalCount);
      setPostsPerPage(list.content.length);

      const count = Math.ceil(list.totalCount / list.content.length / 4);

      for (let i = 1; i <= count; i++) {
        if (currentPage / 4 <= i) {
          setStartIndex(4 * (i - 1));
          return;
        }
      }
    } catch (err) {
      switch (err.response?.status) {
        case 401:
          toast(
            <div>
              인증시간이 만료되었습니다. <br /> 다시 로그인해주세요.
            </div>
          );
          sessionStorage.clear();
          navigate("/admin/login");
          break;
        case 500:
          toast(
            `${
              err.response.data.message
                ? err.response.data.message
                : "서버에 문제가 있습니다. 잠시후 다시 시도해주세요."
            }`
          );
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    let page = Math.ceil(totalCount / postsPerPage);
    let arr = [];
    for (var i = 1; i <= page; i++) {
      arr.push(i);
    }
    setPageIndex(arr);
  }, [totalCount]);

  return (
    <div className="Manage-container">
      <section className="Manage-contents Manage-contents-table">
        <span>거주권 관리</span>
        <div className="manage-table-container">
          <div className="Manage-residency-search-container">
            <div className="Manage-residency-search-number">
              <span>전체 갯수</span>
              <span>{totalCount}</span>
            </div>
            <div className="Manage-residency-search">
              <div style={{ position: "relative" }}>
                <input
                  className="table-search-input"
                  type="text"
                  placeholder="검색어를 입력하세요"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                />
                <img
                  src="/img/search.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    right: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate(`/admin/residency/1?keyword=${searchKeyword}`);
                  }}
                />
              </div>
              <div>
                <Link
                  // onClick={(e) => {
                  //   if (tel.length !== 1) {
                  //     e.preventDefault();
                  //     toast("하나의 거주권을 선택해주세요");
                  //   }
                  // }}
                  to={"/admin/residency/notification/"}
                  state={{ tel: tel }}
                >
                  <span>알림 보내기</span>
                </Link>
              </div>
              <div>
                <Link to={"/admin/member/message"} state={{ tel: tel }}>
                  <span>문자 보내기</span>
                </Link>
              </div>
              <div>
                <a onClick={downloadExcel} className="cursorPointer">
                  <img src="\img\download.svg" />
                  <span>엑셀로 내보내기</span>
                </a>
              </div>
            </div>
          </div>
          <div className="Manage-table manage-table-residency">
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      className="cursorPointer all-check-input"
                      type="checkbox"
                      id={"check"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          let obj = [];
                          const temp = residencyData.map((value) => value.id);
                          residencyData.forEach((item) => {
                            obj.push({
                              ordererName: item.ordererName,
                              ordererTel: item.ordererTel,
                              originPrice: item.originPrice,
                              couponDiscountPrice: item.couponDiscountPrice,
                              useMileage: item.useMileage,
                              paymentPrice: item.paymentPrice,
                              createdAt: moment(item.createdAt).local().format("YYYY/MM/DD"),
                              state: `${
                                item.state === "BEFORE_START"
                                  ? "시작 전"
                                  : item.state === "IN_USE"
                                  ? "사용중"
                                  : item.state === "DONE"
                                  ? "사용 완료"
                                  : "취소"
                              }`,
                              period: `${moment(item.startAt)
                                .local()
                                .format("YYYY/MM/DD")}~ ${moment(item.endAt)
                                .local()
                                .format("YYYY/MM/DD")}`,
                            });
                            const telData = {
                              id: item.member.id,
                              residencyId: item.id,
                              name: item.ordererName,
                              tel: item.ordererTel,
                            };
                            setTel((prev) => [
                              ...prev.filter(
                                (v) => v.residencyId !== telData.residencyId
                              ),
                              telData,
                            ]);
                          });
                          setArr(temp);
                          setExcel(obj);
                        } else {
                          setArr([]);
                          setExcel([]);
                          setTel([]);
                        }
                      }}
                    ></input>
                  </th>
                  <th>주문자명</th>
                  <th>휴대전화</th>
                  <th>원가</th>
                  <th>할인</th>
                  <th>결제</th>
                  <th>생성일</th>
                  <th>상태</th>
                  <th>이용기간</th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                {residencyData.map((residencyItem) => {
                  let createDate = moment(residencyItem.createdAt)
                    .local()
                    .format("YYYY/MM/DD");
                  return (
                    <tr key={residencyItem.id}>
                      <td>
                        <input
                          type="checkbox"
                          id="check1"
                          className="cursorPointer"
                          checked={arr.includes(residencyItem.id)}
                          onChange={(e) => {
                            let obj = {
                           ordererName: residencyItem.ordererName,
                              ordererTel: residencyItem.ordererTel,
                              originPrice: residencyItem.originPrice,
                              couponDiscountPrice: residencyItem.couponDiscountPrice,
                              useMileage: residencyItem.useMileage,
                              paymentPrice: residencyItem.paymentPrice,
                              createdAt: moment(residencyItem.createdAt).local().format("YYYY/MM/DD"),
                              state: `${
                                residencyItem.state === "BEFORE_START"
                                  ? "시작 전"
                                  : residencyItem.state === "IN_USE"
                                  ? "사용중"
                                  : residencyItem.state === "DONE"
                                  ? "사용 완료"
                                  : "취소"
                              }`,
                              period: `${moment(residencyItem.startAt)
                                .local()
                                .format("YYYY/MM/DD")}~ ${moment(residencyItem.endAt)
                                .local()
                                .format("YYYY/MM/DD")}`,
                            };
                            let copyData = [...arr];
                            let copyExcel = [...excel];
                            if (e.target.checked) {
                              copyData.push(residencyItem.id);
                              copyExcel.push(obj);
                              setArr(copyData);
                              setExcel(copyExcel);

                              const telData = {
                                id: residencyItem.member.id,
                                residencyId: residencyItem.id,
                                name: residencyItem.ordererName,
                                tel: residencyItem.ordererTel,
                              };
                              setTel((prev) => [...prev, telData]);
                            } else {
                              let arrTemp = copyData.filter(
                                (item) => item !== residencyItem.id
                              );
                              let excelTemp = copyExcel.filter(
                                (item) =>
                                  item !==
                                  copyExcel.find(
                                    (e) => e.email === residencyItem.email
                                  )
                              );

                              setTel((prev) =>
                                prev.filter((v) => v.id !== residencyItem.id)
                              );
                              setArr(arrTemp);
                              setExcel(excelTemp);
                            }
                          }}
                        ></input>
                        <label htmlFor="check1"></label>
                      </td>
                      <td>{residencyItem.ordererName}</td>
                      <td>{residencyItem.ordererTel}</td>
                      <td>
                        <span>{`${residencyItem.originPrice} 원`}</span>
                      </td>
                      <td>
                        <span>{`${
                          residencyItem.couponDiscountPrice +
                          residencyItem.useMileage
                        } 원`}</span>
                      </td>
                      <td>
                        <span>{`${residencyItem.paymentPrice} 원`}</span>
                      </td>
                      <td>{createDate}</td>
                      <td className="table-sub-catagory-container">
                        {residencyItem.state === "BEFORE_START"
                          ? "시작 전"
                          : residencyItem.state === "IN_USE"
                          ? "사용중"
                          : residencyItem.state === "DONE"
                          ? "사용 완료"
                          : "취소"}
                      </td>
                      <td>
                        {moment(residencyItem.startAt)
                          .local()
                          .format("YYYY/MM/DD")}
                        <br />~{" "}
                        {moment(residencyItem.endAt)
                          .local()
                          .format("YYYY/MM/DD")}
                      </td>
                      <td>
                        <div>
                          <Link
                            to={`/admin/residency/detail/${residencyItem.id}`}
                            state={{ id: residencyItem.id }}
                          >
                            <img src="\img\see-more-btn-plus.svg" />
                            <span>보기</span>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="manage-table-pagenation-container">
              <div className="manage-table-pagenation">
                <a
                  onClick={() => {
                    if (currentPage <= 1) {
                      return;
                    } else {
                      navigate(
                        `/admin/residency/${
                          currentPage - 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-left.svg" />
                </a>
                {pageIndex
                  .slice(startIndex, startIndex + 4)
                  .map((item, index) => {
                    return (
                      <a
                        key={index}
                        className={
                          currentPage === item ? "pagenation-focus" : null
                        }
                        onClick={() => {
                          navigate(
                            `/admin/residency/${item}?keyword=${searchKeyword}`
                          );
                        }}
                      >
                        {item}
                      </a>
                    );
                  })}
                <a
                  onClick={() => {
                    if (currentPage >= pageIndex.length) {
                      return;
                    } else {
                      navigate(
                        `/admin/residency/${
                          currentPage + 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-right.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageResidency;
